import React from 'react';
import { Box, Button, Paper, Typography } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import {
  appliedFilterByOperationStatusSelector,
  appliedFilterByOperationDateSelector,
  appliedFilterByLastNameSelector,
  appliedFilterByNameSelector,
  appliedFilterByDocumentSelector,
  appliedFilterByBatchSelector,
  appliedFilterByOperationTypesSelector,
  filesSelector,
} from 'redux/selectors';
import { setLoading, unSetLoading, setDownloadLink } from 'redux/slices/dataSlice';
import styled from 'styled-components';
import ErrorMessage from 'components/Errors/ErrorMessage';
import { exportFile, resetState, setError } from 'redux/slices/filesSlice';
import { STATUS } from 'constants/thunkStates';
import LimitedBackdropLoading from 'components/Loading/LimitedBackdropLoading';

const StyledPaper = styled(Paper)`
  padding: 2rem;
  margin: auto;
  width: 40vw;
  max-height: 90vh;
  overflow: auto;
  text-align: center;
  border: 2px solid #000;
  box-shadow: ${(p) => p.theme.shadows[5]};
`;

function ExportFileModal({ handleClose }) {
  const dispatch = useDispatch();
  const operationStatus = useSelector(appliedFilterByOperationStatusSelector);
  const operationDate = useSelector(appliedFilterByOperationDateSelector);
  const name = useSelector(appliedFilterByNameSelector);
  const lastName = useSelector(appliedFilterByLastNameSelector);
  const document = useSelector(appliedFilterByDocumentSelector);
  const batch = useSelector(appliedFilterByBatchSelector || '');
  const type = useSelector (appliedFilterByOperationTypesSelector)
  const { status, error } = useSelector(filesSelector);

  const handleExportFile = () => {
    if (!operationStatus && !operationDate && !name && !lastName && !document && !batch && !type) {
      return dispatch(
        setError({
          error: true,
          message: 'No hay filtros aplicados',
        })
      );
    }
    dispatch(setLoading('exportFile'));
    dispatch(exportFile({ operationStatus, operationDate, name, lastName, document, batch, type })).then((res) => {
      if (res.payload.code !== 200) {
        dispatch(resetState());
        dispatch(unSetLoading('exportFile'));
        return
      }
      dispatch(unSetLoading('exportFile'));
      dispatch(setDownloadLink({ type: 'exportFile', link: res.payload.link }))
    });
    handleClose();
  };

  const handleExit = () => {
    handleClose();
    dispatch(resetState());
  };

  return (
    <StyledPaper elevation={3}>
      <Typography variant="text" gutterBottom>
        ¿Desea generar un archivo de los clientes filtrados?
      </Typography>
      {status === STATUS.pending && <LimitedBackdropLoading size={50} />}
      {status === STATUS.error && <ErrorMessage {...error} />}
      <Box
        mt={3}
        p={2}
        display="flex"
        flexDirection="row"
        flexGrow={1}
        justifyContent="center"
      >
        <Box p={1}>
          <Button
            onClick={handleExit}
            fullWidth
            color="secondary"
            variant="contained"
            disabled={status === STATUS.pending ? true : false}
          >
            Cancelar
          </Button>
        </Box>
        <Box p={1}>
          <Button
            onClick={handleExportFile}
            fullWidth
            color="primary"
            variant="contained"
            disabled={status === STATUS.pending ? true : false}
          >
            Generar
          </Button>
        </Box>
      </Box>
    </StyledPaper>
  );
}

export default ExportFileModal;
